import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const mapDepartmentToApiDepartmentDto = (values: IEditDepartmentForm): IPostEditDepartment | {} => {
  let dataMapping: IPostEditDepartment;
  const unknown = -1;

  dataMapping = {
    description: values.description,
    placeID: +values.placeID !== 0 ? +values.placeID : unknown,
    modemID: +values.modemID !== 0 ? +values.modemID : unknown,
    modemPort: values.modemPort,
    unID: values.unID,
    sapCode:values.sapCode,
    deleted: false,
    filepath: values.filepath,
    hubType: values.hubType,
    anetVoice: values.anetVoice,
    comments: values.comments,
    isEmporiki: values.isEmporiki,
    isCiti: values.isCiti,
  }
  
  return dataMapping;
}


const editDepartment = ( {data, departmentId} : {data: IEditDepartmentForm , departmentId: number}): Promise<string> => {
  const department = mapDepartmentToApiDepartmentDto(data);
  return axiosDefaultApi.put(`/api/Departments/UpdateDepartment/${departmentId}`, department);
};

type QueryFnType = typeof editDepartment;

type UseEditDepartmentOptions = {
  data: IPostEditDepartment | {};
  departmentId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditDepartment = ({ config }: UseEditDepartmentOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία της Διεύθυνσης.`, 500);
            console.error('Couldnt edit Department', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllDepartments"])
            addNotification('Η Διεύθυνση Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editDepartment,
    })
}